import "../index.scss";

import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import DiscardChanges from "Components/common/DiscardChanges/DiscardChanges";
import Editor from "Components/common/Conversations/Fields/Editor/Editor";
import Recipient from "./Fields/Recipient/Recipient";
import Links from "./Fields/Links/Links";
import Subject from "./Fields/Subject/Subject";

@connect(store => {
    return {
        conversations: store.conversations,
    };
})

class CreateConversation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: false
        }
        _.map(
            [
                "handleClose",
                "onDiscardChanges",
                "setActiveDragDrop",
                "onDragOver",
                "setActiveDragDrop",
                "onDrop",
            ],
            fn => {
                this[fn] = this[fn].bind(this);
            } );
            this.   veDrag = 0
       
    }

    onDiscardChanges() {
        const { dispatch } = this.props;
        dispatch({ type: "CONVERSATION_TOBE_CLEAR"})
        dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: [] })
        dispatch({ type: "CONVERSATION_FILE_INSERTED", bool: false })
        dispatch({ type: "CLEAR_CONVERSATIONS_FIELDS" });
        $("#createCoversationDisCard").modal("hide");
        $("#create-conversation-form").modal("hide");  
        $('.insert_upload').remove();
        $(".text-editor-inner-container").removeClass("uploaderActive");
    }

    handleClose() {
        const { dispatch, conversations } = this.props;
        const hasChanges = !_.isEqual( conversations.fieldsInit, conversations.fields );

        if(hasChanges) {
            $("#createCoversationDisCard").modal("show");  
        } else {
            dispatch({ type: "CONVERSATION_UPLOADED_FILE", files: [] })
            dispatch({ type: "CONVERSATION_FILE_INSERTED", bool: false })
            dispatch({ type: "CLEAR_CONVERSATIONS_FIELDS" });
            $("#create-conversation-form").modal("hide");
            $('.insert_upload').remove();
            $(".text-editor-inner-container").removeClass("uploaderActive");
        }
    }
    onDragOver(e) {
        if (e) {
            e.preventDefault();
        }
        return false;
    }
    setActiveDragDrop(val) {
        if (val) {
            this.activeDrag += 1;
            this.setState({ isActive: this.activeDrag > 0 });
        } else {
            this.activeDrag -= 1;
            if (this.activeDrag === 0) {
                this.setState({ isActive: false });
            }
        }

    }
    onDrop(e) {
        const { dispatch } = this.props
        if (!e) {
            return;
        }
   
        e.preventDefault();
        this.activeDrag = 0;
        const droppedFiles = e.dataTransfer ? e.dataTransfer.files : [];
        let files = []
        for (let i = 0; i < droppedFiles.length; i++) {
            files.push(droppedFiles[i])
        }
        dispatch({type:"CONVERSATION_UPLOADED_RAW",raw: files,loc:'submit'})
        
        setTimeout(() => {
            this.setState({ isActive: false });
            $('#conversation-droppedFiles').trigger('click')
        }, 1000)
    }

    render() {
        return (
            <div>
                <div class="modal right fade conversation-modal createConvo" id="create-conversation-form" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog">
                        <div class="modal-content"
                            onDragEnter={() => { this.setActiveDragDrop(true) }}
                            onDragOver={this.onDragOver}
                            onDragLeave={() => { this.setActiveDragDrop(false) }}
                            onDrop={this.onDrop}
                        >
                            {this.state.isActive && (
                                <div class="dnd-overlay-container">
                                    <div class="dnd-overlay">Drop files here</div>
                                </div>
                            )}

                            <div class="modal-header">
                                <h4>
                                    Add a New Conversation
                                    <a  class="text-right text-black" aria-label="Close" onClick={ this.handleClose } >
                                        <i class="material-icons text-size22">close</i>
                                    </a>
                                </h4>
                            </div>
                            
                            <div class="modal-body">
                                <form id="create-conversation-form" class="full-form mb0">
                                    <label class="requiredNote">(<sup>*</sup>) Indicates a required field</label>

                                    <div class="conversationModalSection bb pb10">
                                        <Subject />
                                        <Recipient projectId={ this.props.projectId } />
                                        <Links projectId={ this.props.projectId } />
                                    </div>

                                    <div class="conversationModalSection" style={{ padding: 0 }}>
                                        <Editor />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <DiscardChanges onCancel={this.onDiscardChanges} id={'createCoversationDisCard'}/>
            </div>
        );
    }
}

export default CreateConversation;